/**
 * Coveo returns ec_product_id as a multivalue field — a singleton array in
 * practice (see the checked-in search fixtures) — holding a JSON-encoded value
 * (usually a bare number). The CSR path JSON.parses it inline and unguarded,
 * surviving the array only through String coercion; on the SSR path a single
 * malformed value would throw during the server render and error the whole
 * /search route, so unwrap the singleton, parse defensively, and fall back to
 * the raw string.
 */
export function parseProductId(rawId: unknown): string {
  const value = Array.isArray(rawId) && rawId.length === 1 ? rawId[0] : rawId;
  if (typeof value !== 'string' && typeof value !== 'number') {
    return '';
  }
  try {
    return String(JSON.parse(String(value)));
  } catch {
    return String(value);
  }
}
